var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SINGLETEXT"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.cont.title))]),_c('div',{staticClass:"cont"},[_vm._v(_vm._s(_vm.cont.stem))])])
}
var staticRenderFns = []

export { render, staticRenderFns }